module.exports = __webpack_public_path__ + "static/media/american-express.36ab920b.png";